import { useCurrentUser } from './queries';

export const useUserIsSacAdmin = (): boolean => {
  const { user } = useCurrentUser();

  if (!user || !user.email) {
    return false;
  }

  if (user.email.endsWith('@share-a-cart.com')) {
    return true;
  } else {
    return false;
  }
};
